import { DatePicker, Form, Input, Select } from "antd";
import { useEffect } from "react";
const { Option } = Select;

export default function Task({
  form,
  stepData,
  activeStepIndex,
  poolMembers = [],
}) {
  useEffect(() => {
    if (stepData) {
      form.setFieldsValue({
        taskTitle: stepData?.task?.taskTitle || undefined,
        taskOwner: stepData?.task?.taskOwner || undefined,
        projectDuration: stepData?.task?.projectDuration || undefined,
      });
    } else {
      form.resetFields();
    }
  }, [stepData, form, activeStepIndex]);

  return (
    <Form layout="vertical" name="taskForm" form={form}>
      <Form.Item label="Task Title" name="taskTitle">
        <Input placeholder="Enter task title" />
      </Form.Item>
      <Form.Item label="Owner" name="taskOwner">
        <Select placeholder="Select owner">
          {poolMembers?.map((owner, index) => (
            <Option value={owner?.user_id}>{owner?.user_first_name}</Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label="Duration" name="projectDuration">
        <DatePicker style={{ width: "100%" }} />
      </Form.Item>
    </Form>
  );
}
